export default __webpack_public_path__ + "static/media/flores-mobile.f07ca9ac.svg";